/**
 * https://stripe.com/docs/currencies#minimum-and-maximum-charge-amounts
 * @readonly
 * @enum {string}
 */
module.exports = {
    USD: 2,
    AED: 7,
    AFN: 180,
    ALL: 230,
    AMD: 1000,
    ANG: 4,
    AOA: 950,
    ARS: 215,
    AUD: 3,
    AWG: 4,
    AZN: 3,
    BAM: 4,
    BBD: 4,
    BDT: 170,
    BGN: 4,
    BIF: 4000,
    BMD: 2,
    BND: 3,
    BOB: 15,
    BRL: 10,
    BSD: 2,
    BWP: 23,
    BYN: 6,
    BZD: 4,
    CAD: 3,
    CDF: 4000,
    CHF: 2,
    CLP: 1615,
    CNY: 13,
    COP: 7650,
    CRC: 1300,
    CVE: 200,
    CZK: 50,
    DJF: 350,
    DKK: 15,
    DOP: 100,
    DZD: 280,
    EGP: 30,
    ETB: 100,
    EUR: 2,
    FJD: 4,
    FKP: 2,
    GBP: 2,
    GIP: 2,
    GMD: 100,
    GNF: 18000,
    GTQ: 15,
    GYD: 415,
    HKD: 15,
    HNL: 50,
    HRK: 16,
    HTG: 210,
    HUF: 725,
    IDR: 28500,
    ILS: 7,
    INR: 150,
    ISK: 260,
    JMD: 300,
    JPY: 230,
    KES: 230,
    KGS: 190,
    KHR: 8150,
    KMF: 900,
    KRW: 2450,
    KYD: 2,
    KZT: 1020,
    LAK: 22800,
    LBP: 3000,
    LKR: 400,
    LRD: 300,
    LSL: 30,
    MAD: 20,
    MDL: 35,
    MGA: 7950,
    MKD: 110,
    MMK: 3550,
    MNT: 5750,
    MOP: 15,
    MRO: 715,
    MUR: 90,
    MVR: 30,
    MWK: 1600,
    MXN: 40,
    MYR: 8,
    MZN: 120,
    NAD: 30,
    NGN: 830,
    NIO: 70,
    NOK: 20,
    NPR: 250,
    NZD: 3,
    PAB: 2,
    PEN: 7,
    PGK: 7,
    PHP: 105,
    PKR: 350,
    PLN: 10,
    PYG: 13950,
    QAR: 7,
    RON: 10,
    RSD: 215,
    RUB: 250,
    RWF: 2050,
    SAR: 8,
    SBD: 15,
    SCR: 25,
    SEK: 20,
    SGD: 3,
    SHP: 2,
    SLL: 22950,
    SOS: 1150,
    SRD: 40,
    STD: 42750,
    SZL: 30,
    THB: 65,
    TJS: 25,
    TOP: 5,
    TRY: 30,
    TTD: 13,
    TWD: 55,
    TZS: 4620,
    UAH: 60,
    UGX: 7215,
    UYU: 85,
    UZS: 21750,
    VND: 45700,
    VUV: 230,
    WST: 5,
    XAF: 1200,
    XCD: 5,
    XOF: 1200,
    XPF: 220,
    YER: 500,
    ZAR: 30,
    ZMW: 35,
};
